if (!customElements.get('editorial-story-slider')) {
  customElements.define('editorial-story-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.es-track');
      if (!this.track) return;
      this.track.querySelectorAll('[data-loop-clone]').forEach(slide => slide.remove());
      this.slides = [...this.querySelectorAll('.es-slide')];
      this.loop = this.slides.length > 1;
      if (this.loop) {
        const clone = slide => {
          const copy = slide.cloneNode(true);
          copy.setAttribute('data-loop-clone', '');
          copy.removeAttribute('data-shopify-editor-block');
          copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          return copy;
        };
        this.track.prepend(clone(this.slides[this.slides.length - 1]));
        this.track.append(clone(this.slides[0]));
        this.track.scrollTo({ left: this.track.clientWidth, behavior: 'instant' });
      }
      this.physicalSlides = [...this.track.querySelectorAll('.es-slide')];
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.go = (index) => {
        const target = this.loop ? Math.max(-1, Math.min(this.slides.length, index)) + 1 : 0;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.index = () => {
        const physical = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
        return this.loop ? (physical - 1 + this.slides.length) % this.slides.length : 0;
      };
      this.settle = () => {
        if (!this.loop) return;
        const width = this.track.clientWidth;
        const physical = Math.round(this.track.scrollLeft / (width || 1));
        if (Math.abs(this.track.scrollLeft - physical * width) > 2) return;
        if (physical === 0 || physical === this.slides.length + 1) {
          this.track.scrollTo({ left: (physical === 0 ? this.slides.length : 1) * width, behavior: 'instant' });
        }
      };
      this.update = () => {
        const index = this.index();
        const previous = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index >= this.slides.length - 1;
        const counter = this.querySelector('.es-counter');
        if (counter) counter.textContent = `${index + 1} / ${this.slides.length}`;
        const active = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
        const activeSlide = this.physicalSlides[active];
        const photoLink = this.parentElement.querySelector('.es-photo-link');
        if (photoLink && activeSlide) {
          const href = activeSlide.dataset.productLink;
          photoLink.hidden = !href;
          if (href) photoLink.setAttribute('href', href);
          else photoLink.removeAttribute('href');
          photoLink.setAttribute('aria-label', activeSlide.dataset.productTitle || 'View product');
        }
        this.physicalSlides.forEach((slide, i) => {
          slide.inert = i !== active;
          slide.setAttribute('aria-hidden', String(i !== active));
        });
      };
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index() - 1), opts);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index() + 1), opts);
      this.track.addEventListener('scroll', () => {
        this.update();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(this.settle, 140);
      }, opts);
      this.track.addEventListener('scrollend', this.settle, opts);
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.go(this.index() + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      }, opts);
      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.startX = event.clientX; this.startIndex = this.index(); this.dragged = false;
      }, opts);
      window.addEventListener('pointerup', (event) => {
        if (this.startX == null) return;
        const delta = event.clientX - this.startX;
        if (Math.abs(delta) > 40) { this.dragged = true; this.go(this.startIndex + (delta < 0 ? 1 : -1)); }
        this.startX = null;
      }, opts);
      this.track.addEventListener('dragstart', (event) => event.preventDefault(), opts);
      this.track.addEventListener('click', (event) => { if (this.dragged) { event.preventDefault(); this.dragged = false; } }, { ...opts, capture: true });
      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.es-slide');
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.go(index);
      }, opts);
      this.resize = new ResizeObserver(this.update); this.resize.observe(this.track);
      this.update();
      if (this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => {
          if (document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
          const rect = this.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > innerHeight) return;
          this.go(this.index() + 1);
        }, Number(this.dataset.interval) || 5000);
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); clearInterval(this.timer); clearTimeout(this.settleTimer); this.track?.querySelectorAll('[data-loop-clone]').forEach(slide => slide.remove()); }
  });
}
